/**
 * Evening send-time options for the SMS daily digest — the single list shared
 * by the onboarding step (YAR-284 AC14) and Settings → Notifications
 * (YAR-266 AC1-8).
 *
 * Range is 5:00–8:30 PM at half-hour steps. Half hours matter: YAR-266
 * shipped 7:30 PM and 8:30 PM, so beta admins already have 1170 / 1230
 * persisted in `notification_preferences.digest_send_minutes`. An hourly-only
 * list would strand those values on a synthetic "(current)" entry that
 * disappears the moment the picker is touched.
 *
 * Every value sits inside the DB CHECK range (480–1260) and inside the
 * TCPA 8:00 AM–9:00 PM floor the dispatcher enforces.
 *
 * 9:00 PM (1260) is deliberately NOT offered, though it is legal. The digest
 * is due "at or after" the chosen minute and stays due until sent, so a
 * missed cron tick can never lose a day (YAR-267) — but that slack is bounded
 * by the same 9:00 PM legal ceiling. At 1260 the two collapse onto each
 * other: `isDigestDue` is true only while local time reads exactly 21:00, and
 * `run_send_daily_digest_cron` ticks every 15 minutes. One late or slow tick
 * and the digest silently does not go out that day — the only option in this
 * list with no second chance. Every remaining option keeps ≥30 minutes of it.
 *
 * Anyone who already saved 1260 keeps it: Settings renders an off-list value
 * as "9:00 PM (current)" rather than dropping it (see `isKnownDigestMinutes`),
 * so removing the option strands nobody — but those users stay on the fragile
 * minute until they pick another time.
 */
export const DEFAULT_DIGEST_MINUTES = 1140; // 7:00 PM

export const DIGEST_TIME_OPTIONS = [
  { value: 1020, label: '5:00 PM' },
  { value: 1050, label: '5:30 PM' },
  { value: 1080, label: '6:00 PM' },
  { value: 1110, label: '6:30 PM' },
  { value: 1140, label: '7:00 PM' },
  { value: 1170, label: '7:30 PM' },
  { value: 1200, label: '8:00 PM' },
  { value: 1230, label: '8:30 PM' },
] as const;
